import classNames from "classnames";
// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class PageTab extends React.Component {
    render() {
        const { callback, label } = this.props;
        return (React.createElement("li", { className: "" },
            React.createElement("span", { className: classNames(this.props.isActive && "active"), onClick: () => callback() }, label)));
    }
}
